import React from 'react';
import { defaultTemplate } from 'core/hoc';

function HomeTemplate({ t }) {
	return (
		<div className="container--404">
			<div className="w--400--px align--h--center type--center">
				<img className="display--b spc--bottom--med" src={require('themes/img/es-welcome.svg')} />
				<p className="spc--bottom--med w--450--px align--h--center type--lrg">{t('WELCOME')}</p>
			</div>
		</div>
	);
}

export default defaultTemplate(HomeTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/modules/root/pages/HomeTemplate.jsx